document.addEventListener('DOMContentLoaded', function () {
    const targetNode = document.querySelector('.productView-options');

    if (!targetNode) {
        console.log('Cannot find watch target element');
        return;
    }

    const observer = new MutationObserver(handleMutations);
    const config = { childList: true, subtree: true, characterData: true, attributes: true };

    observer.observe(targetNode, config);

    // Initial setup
    handleMutations();

    function handleMutations() {
        const elements = Array.from(document.querySelectorAll('.form__label')).slice(0, 3);

        if (elements.length > 0) {
            const result = getElementValues(elements);
            updateSpecification(result);
            updateFiveDescription(result);
            updateOverview(result);
            updateDocument(result);
        } //else {
            // console.log('Cannot find matched elements');
        // }
    }

    function getElementValues(elements) {
        // 提取每个元素的span文本内容并过滤空值
        const values = elements.map(element => {
            const span = element.querySelector('span');
            return span ? span.textContent.trim() : '';
        }).filter(value => value !== '');

        // 如果数组为空返回空字符串，否则用 " / " 连接
        return values.length === 0 ? '' : values.length === 1 ? values[0] : values.join(" / ");
    }

    function updateSpecification(result) {
        const containers = document.querySelectorAll('.GGJIA-specification-container');

        containers.forEach(container => {
            container.style.display = 'none';
        });

        const matchingContainer = document.querySelector(`.GGJIA-specification-container[data-variant-title="${result}"]`);
        if (matchingContainer) {
            matchingContainer.style.display = 'block';
        } // else {
            // console.log('Cannot find GGJIA-specification container');
        // }
    }

    const cleanupValues = () => {
        document.querySelectorAll('.specification-value').forEach(span => {
            span.textContent = span.textContent.replace(/&nbsp;/g, ' ').trim();
        });
    };

    // Call the function to clean up values
    cleanupValues();

    // 移动端查看更多功能
    const fullLists = document.querySelectorAll(".five-point-list");
    const isMobile = window.matchMedia("(max-width: 768px)").matches; // 修正了移动端检测条件

    if (isMobile) {
        fullLists.forEach(fullList => {
            const seeMoreBtn = fullList.nextElementSibling;
            const items = fullList.querySelectorAll("li");

            // 初始状态
            for (let i = 1; i < items.length; i++) {
                items[i].style.display = "none";
            }
            seeMoreBtn.style.display = "block";

            // 事件处理
            seeMoreBtn.addEventListener("click", function () {
                const isExpanded = seeMoreBtn.textContent === "See less";

                // 切换显示
                for (let i = 2; i < items.length; i++) {
                    items[i].style.display = isExpanded ? "none" : "list-item";
                }

                // 更新按钮状态
                seeMoreBtn.textContent = isExpanded ? "See more" : "See less";
                seeMoreBtn.classList.toggle("see-less", !isExpanded);
            });
        });
    }

    const fullList = document.getElementById("five-point-list");
    const seeMoreBtn = document.getElementById("see-more-btn");
    const items = fullList.getElementsByTagName("li");
    
    // 初始状态：只显示前两项
    if (items.length > 2) {
      for (let i = 1; i < items.length; i++) {
        items[i].style.display = "none";
      }
      seeMoreBtn.style.display = "block"; // 确保按钮显示
    } else {
      seeMoreBtn.style.display = "none"; // 如果不足两项，隐藏按钮
    }

    // 添加点击事件
    seeMoreBtn.addEventListener("click", function () {
      // 切换隐藏项的显示状态
      for (let i = 2; i < items.length; i++) {
        if (items[i].style.display === "none") {
          items[i].style.display = "list-item";
        } else {
          items[i].style.display = "none";
        }
      }

      // 切换按钮文本
      if (seeMoreBtn.textContent === "See less") {
        seeMoreBtn.textContent = "See more";
        seeMoreBtn.classList.add("see-more");
      } else {
        seeMoreBtn.textContent = "See less";
        seeMoreBtn.classList.remove("see-more");
      }
    });

    // 更新5点显示函数
    function updateFiveDescription(result) {
        const containers = document.querySelectorAll(".GGJIA-five-point-container");

        containers.forEach(container => {
            container.style.display = "none";
        });

        const matchingContainer = document.querySelector(`.GGJIA-five-point-container[data-variant-title="${result}"]`);
        if (matchingContainer) {
            matchingContainer.style.display = "block";
        } 
        // else {
        //     console.log("Cannot find matching five-point container");
        // }
    }

    // 图片切换功能
    function changeImage(imageSrc) {
        const productImage = document.getElementById('productImage');
        if (productImage) {
            productImage.src = imageSrc;
        }
    }

    // 切换Overview
    function updateOverview(result) {
        const containers = document.querySelectorAll(".specification-img");

        containers.forEach(container => {
            container.style.display = "none";
        });

        const matchingContainer = document.querySelector(`.specification-img[data-variant-title="${result}"]`);
        if (matchingContainer) {
            matchingContainer.style.display = "block";
        } 
        // else {
        //     console.log("Cannot find specification-img container");
        // }
    }

    // 切换Documents
    function updateDocument(result) {
        const containers = document.querySelectorAll(".document-a");

        containers.forEach(container => {
            container.style.display = "none";
        });

        const matchingContainer = document.querySelector(`.document-a[data-variant-title="${result}"]`);
        if (matchingContainer) {
            matchingContainer.style.display = "block";
        } 
        // else {
        //     console.log("Cannot find document-a container");
        // }
    }

    // Watt Guide 功能
    const guideLabel = document.querySelector('.guide-label');
    const wattGuide = document.querySelector('.product-watt_guide');
    const closeBtn = document.querySelector('.product-watt_guide .close');

    if (guideLabel && wattGuide && closeBtn) {
        // 打开 Watt Guide
        guideLabel.addEventListener('click', function () {
            wattGuide.classList.add('active');
            document.body.style.overflow = 'hidden'; // 防止背景滚动
        });

        // 关闭 Watt Guide
        closeBtn.addEventListener('click', function () {
            wattGuide.classList.remove('active');
            document.body.style.overflow = ''; // 恢复滚动
        });

        // 点击背景关闭
        wattGuide.addEventListener('click', function (e) {
            if (e.target === wattGuide) {
                wattGuide.classList.remove('active');
                document.body.style.overflow = '';
            }
        });

        // ESC键关闭
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && wattGuide.classList.contains('active')) {
                wattGuide.classList.remove('active');
                document.body.style.overflow = '';
            }
        });
    }
});